import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

export const businessRelationSerializeMap: SerializeMap<BusinessRelation> = {
  id: "id",
  relationType: "relation_type",
  relatedFromId: "related_from_id",
  relatedToId: "related_to_id",
  rateType: "rate_type",
  rateValue: "rate_value",
  saleType: "sale_type",
  saleSubTypeId: "sale_sub_type_id",
  speciesId: "species_id",
};

export const serializeBusinessRelation = buildSerializer(
  businessRelationSerializeMap,
  "BusinessRelation",
);

export const deserializeBusinessRelation = buildDeserializer(
  businessRelationSerializeMap,
  "BusinessRelation",
);
